import { useEffect, useState, createContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
export const CityProfileVisibleContext = createContext<any>(null);

const CityProfileVisibleProvider = ({ children }: any) => {
  const [visible, setVis] = useState<boolean>(true);
  const matches = useMediaQuery("(max-width:1000px)");

  useEffect(() => {
    if (matches) {
      setVis(false);
    }
  }, []);

  return (
    <CityProfileVisibleContext.Provider
      value={{ visible, setVis }}
    >
      {children}
    </CityProfileVisibleContext.Provider>
  );
};

export default CityProfileVisibleProvider;
